// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (orientation: landscape) and (max-height: 500px) {\n.template-header-menu {\n        display: block !important;\n}\n.template-main-content {\n        padding-left: 0 !important;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
